import { render, staticRenderFns } from "./QrSettings.vue?vue&type=template&id=4c1dd42e"
import script from "./QrSettings.vue?vue&type=script&lang=ts"
export * from "./QrSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1dd42e')) {
      api.createRecord('4c1dd42e', component.options)
    } else {
      api.reload('4c1dd42e', component.options)
    }
    module.hot.accept("./QrSettings.vue?vue&type=template&id=4c1dd42e", function () {
      api.rerender('4c1dd42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/QrSettings.vue"
export default component.exports